var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "TabsContainer",
    {
      staticClass: "tabs-container-wrapper guide-forms-settings",
      attrs: { tabNames: _vm.tabNames },
    },
    [
      _c(
        "div",
        { attrs: { slot: "tab-0" }, slot: "tab-0" },
        [
          _vm.allowEdit()
            ? _c("HkldDropzone", {
                attrs: {
                  sourceId: _vm.DOCS_SOURCE_TYPE.USER_GUIDE,
                  action: _vm.ActionTypes.settings.doc.userGuide.create,
                  metaData: _vm.guideDefaultOptions,
                  uploadDocTypes: _vm.MIME_TYPES.ALL,
                  uploadDocMaxSize: 1024,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("EditUserGuide", {
            attrs: {
              sourceId: _vm.DOCS_SOURCE_TYPE.USER_GUIDE,
              canEdit: _vm.allowEdit(),
              canDelete: _vm.allowEdit(),
              canDownloadAll: false,
              action: _vm.ActionTypes.settings.doc.userGuide.delete,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "tab-1" }, slot: "tab-1" },
        [
          _vm.allowEdit()
            ? _c("HkldDropzone", {
                attrs: {
                  sourceId: _vm.DOCS_SOURCE_TYPE.FORMS,
                  action: _vm.ActionTypes.settings.doc.forms.create,
                  metaData: _vm.formsDefaultOptions,
                  uploadDocTypes: _vm.MIME_TYPES.ALL,
                  uploadDocMaxSize: 1024,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("EditForms", {
            attrs: {
              sourceId: _vm.DOCS_SOURCE_TYPE.FORMS,
              canEdit: _vm.allowEdit(),
              canDelete: _vm.allowEdit(),
              canDownloadAll: false,
              action: _vm.ActionTypes.settings.doc.forms.delete,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }